window.addEventListener('DOMContentLoaded', function() {
var toggle_btn = document.querySelector('.content-toggle-btn');
if(toggle_btn){
document.querySelector('.content-toggle-btn').addEventListener('click', function (e) {
    e.preventDefault();
  const content = document.querySelector('.section-boxed.collection-description');

  content.classList.toggle('expanded');

  this.textContent = content.classList.contains('expanded')
    ? 'Minder weergeven'
    : 'Meer weergeven';
});
}

document.addEventListener('click', function(e) {
  const btn = e.target.closest('.banner-review-widget .fera-reviews-header-summary');
  if (!btn) return;

  const target = document.querySelector('.fera-widget-container');

  if (target) {
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
});

  function createMobileScrollbar(containerSelector) {

    const containers = document.querySelectorAll(containerSelector);

    containers.forEach((scrollContainer) => {

      if (!scrollContainer) return;

      // avoid duplicate scrollbar
      if (scrollContainer.nextElementSibling?.classList.contains('custom-scrollbar')) {
        return;
      }

      const scrollbar = document.createElement('div');

      scrollbar.classList.add('custom-scrollbar');

      scrollbar.style.cssText = `
        width:100%;
        height:2px;
        background:#d9d9d9;
        border-radius:20px;
        overflow:hidden;
        position:relative;
      `;

      const progress = document.createElement('div');
      progress.style.cssText = `
        height:100%;
        width:30%;
        background:#111;
        border-radius:20px;
        transition:width .1s linear;
      `;
      scrollbar.appendChild(progress);
      scrollContainer.insertAdjacentElement('afterend', scrollbar);

      function updateScroll() {
        const maxScroll =
          scrollContainer.scrollWidth - scrollContainer.clientWidth;

        if (maxScroll <= 0) {
          progress.style.width = '100%';
          return;
        }

        const scrollPercent =
          scrollContainer.scrollLeft / maxScroll;

        // starts from 30%
        const width =
          30 + ((100 - 30) * scrollPercent);

        progress.style.width = width + '%';
      }

      scrollContainer.addEventListener('scroll', updateScroll);

      updateScroll();

    });

  }
  createMobileScrollbar('.feature-grid-wrapper,.feature-chart__table,.process,.table-inner-container,.trust-badges,.related-products-grid,.fera-reviews-body-items,.trust-indicators-grid,.blog-posts.scroll-area,.collection-tabs,.main-collection-tab-container scroll-carousel,.process-grid');

  fera.api.listReviews().then(({ meta, reviews }) => {
  console.log(`Found ${ meta.total_count } reviews`);
   var review_count_container = document.querySelector('.hero-banner-main .banner-review-widget .fera-averageRating-count-total');
   if(review_count_container){
    review_count_container.innerText = meta.total_count;
   }
});
});

/* 19-08-2026: mobiele collectie-intro inkorten tot ~6 regels met Lees meer-knop */
(function () {
  function initIntroClamp() {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    if (location.pathname.indexOf('/collections/') === -1) return;
    var sections = document.querySelectorAll('.shopify-section--rich-text .prose');
    for (var i = 0; i < sections.length; i++) {
      var prose = sections[i];
      var paras = prose.querySelectorAll('p');
      for (var j = 0; j < paras.length; j++) {
        var p = paras[j];
        if (p.getBoundingClientRect().height > 260 && !p.classList.contains('cf-intro-clamp')) {
          p.classList.add('cf-intro-clamp');
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.textContent = 'Lees meer';
          btn.className = 'cf-intro-toggle';
          (function (pEl, bEl) {
            bEl.addEventListener('click', function () {
              var open = pEl.classList.toggle('cf-intro-open');
              bEl.textContent = open ? 'Lees minder' : 'Lees meer';
            });
          })(p, btn);
          p.after(btn);
          return; // alleen de eerste lange alinea
        }
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIntroClamp);
  } else {
    initIntroClamp();
  }
})();


/* 19-08-2026: tekstfix staffel-widget: "10%korting" -> "10% korting" */
(function(){
  var pogingen=0;
  var t=setInterval(function(){
    pogingen++;
    var w=document.getElementById('prvw__bundle_container');
    if(w){
      var els=w.querySelectorAll('*');
      for(var i=0;i<els.length;i++){
        var el=els[i];
        if(el.children.length===0 && /%korting/.test(el.textContent)){
          el.textContent=el.textContent.replace(/%korting/g,'% korting');
        }
      }
      clearInterval(t);
    }
    if(pogingen>20) clearInterval(t);
  }, 500);
})();
